import React from "react";

function Einzelunterricht() {
    return (
        <div class="uk-container uk-padding">
            <h2>Einzelunterricht</h2>
            <div class="uk-text-left">
                <h4><b>Für Kinder</b></h4>
                <ul>
                    <li>Gezielte Förderung bei Kindern z.B. mit Konzentrationsschwierigkeiten</li>
                    <li>Individuelle Begleitung für den persönlichen Prozess</li>
                
                </ul>
                <h4><b>Für Erwachsene</b></h4>
                <ul>
                    <li>Individuelle Begleitung für den persönlichen Prozess</li>
                </ul>
                <br></br>               
                <p>Termin und Preis auf Anfrage. Ruft mich an, dann können wir alles weitere besprechen. <a href="tel:+4944885204588">Jetzt anrufen</a></p>

            </div>
            <br></br>
        </div>
    );
}

export default Einzelunterricht;